/**
 * Componente ScrollToTop
 * Hace scroll automático al inicio de la página cuando cambia la ruta
 * 
 * Este componente escucha los cambios de ubicación (pathname) del router
 * y ejecuta un scroll instantáneo hacia arriba cada vez que el usuario navega
 * a una nueva página. Compatible con Lenis smooth scroll.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook que realiza scroll al top cuando cambia la ruta
 * @returns {null} No renderiza nada, solo ejecuta el efecto
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll instantáneo al inicio de la página
    // Usamos setTimeout para asegurar que se ejecute después del renderizado
    const scrollToTop = () => {
      // Primero intentamos con scroll nativo
      window.scrollTo(0, 0);
      
      // También forzamos el scroll del documento
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Si existe Lenis en el DOM, lo reseteamos también
      if (window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true });
      }
    };

    // Ejecutar inmediatamente
    scrollToTop();
    
    // Reforzar después de que Lenis se inicialice
    const timer1 = setTimeout(scrollToTop, 50);
    const timer2 = setTimeout(scrollToTop, 100);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
